// import { useState, useEffect } from "react";
// import axios from "axios";
// import { api } from "../api/api";
// import { unknownError } from "../utils/unknownError";

// export function useFetch(url, options = {}) {
//   const { run = true } = options;
//   const [data, setData] = useState();
//   const [loading, setLoading] = useState(false);
//   const [refetcher, setRefetcher] = useState(false);
// console.log(loading);
//   useEffect(() => {
//     if (!run || !url) return;
//     setLoading(true);
//     const source = axios.CancelToken.source();
//     const fetchData = async () => {
//       setData(undefined);
//       try {
//         const res = await api.get(url, { cancelToken: source.token });
//         res.data && setData(res.data);
//       } catch (err) {
//         unknownError(err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();

//     return () => {
//       source.cancel();
//     };
//   }, [url, refetcher, run]);

//   const refetch = () => {
//     setRefetcher((v) => !v);
//   };

//   return { data, loading, refetch };
// }
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { api } from "../api/api";
import { unknownError } from "../utils/unknownError";

export function useFetch(url, options = {}) {
  const { run = true } = options;

  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [refetcher, setRefetcher] = useState(false);

  // 🔒 track latest request
  const requestIdRef = useRef(0);

  useEffect(() => {
    if (!run || !url) return;

    const source = axios.CancelToken.source();
    const requestId = ++requestIdRef.current;

    setLoading(true);

    const fetchData = async () => {
      try {
        const res = await api.get(url, {
          cancelToken: source.token,
        });

        // ✅ only update if this is the latest request
        if (requestId === requestIdRef.current) {
          setData(res.data);
          setLoading(false);
        }
      } catch (err) {
        if (!axios.isCancel(err)) {
          unknownError(err);
          if (requestId === requestIdRef.current) {
            setLoading(false);
          }
        }
      }
    };

    fetchData();

    return () => {
      source.cancel();
    };
  }, [url, refetcher, run]);

  const refetch = () => setRefetcher((v) => !v);

  return { data, loading, refetch };
}
